import * as React from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Header from './components/Header.tsx';
import Footer from './components/Footer.tsx';
import AppTheme from '../shared-theme/AppTheme.tsx';
import Blogs from "./components/Blogs.tsx";
import Videos from "./components/Videos.tsx";
import AboutUs from "./components/AboutUs.tsx";
import MicroServicesBlog01 from "./components/blogs/MicroServicesBlog01.tsx";
import EventBusDesignPatternBlog02 from "./components/blogs/EventBusDesignPatternBlog02.tsx";
import FeatureFlagsBlog03 from "./components/blogs/FeatureFlagsBlog03.tsx";
import TestDrivenDevelopmentBlog04 from "./components/blogs/TestDrivenDevelopmentBlog04.tsx";
import ReactCompoundComponentsBlog05 from "./components/blogs/ReactCompoundComponentsBlog05.tsx";
import SolidPrinciplesBlog06 from "./components/blogs/SolidPrinciplesBlog06.tsx";
import Legal from './components/Legal.tsx';
import FY2526Returns from './components/FY2526Returns.tsx';
import SyteFlowApp from './components/syteflow/SyteFlowApp.tsx';
import SyteflowPrivacy from './components/syteflow/SyteflowPrivacy.tsx';
import SyteflowTerms from './components/syteflow/SyteflowTerms.tsx';
import Home from "./components/Home.tsx";


function LayoutWrapper() {
  return (
    <>
      <Header />
      <Outlet />
      <Divider />
      <Footer />
    </>
  );
}

export default function AliatisPage(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Router>
        <Routes>
          <Route  element={<LayoutWrapper><Home /></LayoutWrapper>}>
            <Route path="/blogs" element={<Blogs />} >
              <Route index element={<SolidPrinciplesBlog06 />} />
              <Route path="/blogs/microservices-nodejs" element={<MicroServicesBlog01 />} />
              <Route path="/blogs/event-bus-designpattern-nodejs" element={<EventBusDesignPatternBlog02 />} />
              <Route path="/blogs/feature-flags-and-controlled-rollouts" element={<FeatureFlagsBlog03 />} />
              <Route path="/blogs/test-driven-development-nodejs" element={<TestDrivenDevelopmentBlog04 />}/>
              <Route path="/blogs/compound-components-reactjs" element={<ReactCompoundComponentsBlog05 />}/>
              <Route path="/blogs/solid-principles-js" element={<SolidPrinciplesBlog06 />}/>
            </Route>
            <Route path="/videos" element={<Videos />}/>
            <Route path="/aboutus" element={<AboutUs />}/>
            <Route path="/legal" element={<Legal />}/>
            <Route path="/legal/FY25_26_Returns" element={<FY2526Returns />}/>
            <Route path="/legal/:location" element={<Legal />}/>
            <Route path="/" element={<Home />} />
          </Route>
          <Route>
            <Route path="/products/syteflow/learn-more" element={<SyteFlowApp />}/>
            <Route path="/products/syteflow/support" element={<SyteFlowApp />}/>
            <Route path="/products/syteflow/privacy-policy" element={<SyteflowPrivacy />}/>
            <Route path="/products/syteflow/terms-and-conditions" element={<SyteflowTerms />}/>
          </Route>
        </Routes>
      </Router>
    </AppTheme>
  );
}
